"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnTabPanes = exports.ReturnedSaleLineStatusTypes = exports.ReturnedSaleStatusTypes = exports.RefundInformationMessageType = exports.ReturnLocations = void 0;
var ReturnLocations;
(function (ReturnLocations) {
    ReturnLocations["STORE"] = "STORE";
    ReturnLocations["WAREHOUSE"] = "WAREHOUSE";
})(ReturnLocations || (exports.ReturnLocations = ReturnLocations = {}));
var RefundInformationMessageType;
(function (RefundInformationMessageType) {
    RefundInformationMessageType["KLARNA"] = "KLARNA";
    RefundInformationMessageType["SAFERPAY"] = "SAFERPAY";
    RefundInformationMessageType["OTHER"] = "OTHER";
})(RefundInformationMessageType || (exports.RefundInformationMessageType = RefundInformationMessageType = {}));
var ReturnedSaleStatusTypes;
(function (ReturnedSaleStatusTypes) {
    ReturnedSaleStatusTypes["ANNOUNCED"] = "announced";
    ReturnedSaleStatusTypes["COMPLETED"] = "completed";
})(ReturnedSaleStatusTypes || (exports.ReturnedSaleStatusTypes = ReturnedSaleStatusTypes = {}));
var ReturnedSaleLineStatusTypes;
(function (ReturnedSaleLineStatusTypes) {
    ReturnedSaleLineStatusTypes["ANNOUNCED"] = "P";
    ReturnedSaleLineStatusTypes["RETURNED"] = "R";
})(ReturnedSaleLineStatusTypes || (exports.ReturnedSaleLineStatusTypes = ReturnedSaleLineStatusTypes = {}));
var ReturnTabPanes;
(function (ReturnTabPanes) {
    ReturnTabPanes[ReturnTabPanes["RETURN_ITEMS"] = 0] = "RETURN_ITEMS";
    ReturnTabPanes[ReturnTabPanes["REGISTERED_RETURNS"] = 1] = "REGISTERED_RETURNS";
})(ReturnTabPanes || (exports.ReturnTabPanes = ReturnTabPanes = {}));
//# sourceMappingURL=OrdersTypes.js.map